package nl.volleyplanner.web.component.backend_jobs

import kotlinx.coroutines.flow.StateFlow
import kotlinx.datetime.format
import kotlinx.html.*
import nl.volleyplanner.web.DATE_TIME_FORMAT
import nl.volleyplanner.web.base.SpinnerStyle
import nl.volleyplanner.web.base.component.ModalComponent
import nl.volleyplanner.web.base.spinner

class JobProgressModal(
    val jobFlowState: StateFlow<JobFlowState>,
    buttonLabel: String
) : ModalComponent(
    buttonLabel
) {
    override fun FlowContent.renderBody() {
        div {
            if (!jobFlowState.value.isCompleted()) {
                span (classes="badge text-bg-secondary") {
                    spinner(SpinnerStyle.Grow, small = true)
                    +"Bezig... [${jobFlowState.value.pollIndex}]"
                }
            } else {
                val badgeCss = when {
                    jobFlowState.value.jobExecution!!.cloudJobExecution!!.failedCount > 0 -> "text-bg-danger"
                    jobFlowState.value.jobExecution!!.cloudJobExecution!!.runningCount > 0 -> "text-bg-secondary"
                    jobFlowState.value.jobExecution!!.cloudJobExecution!!.succeededCount > 0 -> "text-bg-success"
                    else -> "text-bg-info"
                }
                span (classes="badge $badgeCss") { +"Klaar" }
            }
        }
        dl (classes = "row") {
            dt (classes = "col-sm-4") { +"Taken" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution!!.taskCount}" }
            dt (classes = "col-sm-4") { +"Bezig" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution!!.runningCount}" }
            dt (classes = "col-sm-4") { +"Compleet" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution!!.succeededCount}" }
            dt (classes = "col-sm-4") { +"Gefaald" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution!!.failedCount}" }
            dt (classes = "col-sm-4") { +"Aangemaakt" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution!!.createTime.format(DATE_TIME_FORMAT)}" }
            dt (classes = "col-sm-4") { +"Gestart" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution?.startTime?.format(DATE_TIME_FORMAT)}" }
            dt (classes = "col-sm-4") { +"Klaar" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution?.completionTime?.format(
                DATE_TIME_FORMAT
            )}" }
            dt (classes = "col-sm-4") { +"Laatste update" }
            dd (classes = "col-sm-8") { +"${jobFlowState.value.jobExecution!!.cloudJobExecution?.updateDateTime?.format(
                DATE_TIME_FORMAT
            )}" }
        }
    }

    override suspend fun getState() = jobFlowState
}